// extracted by mini-css-extract-plugin
export default {"countText":"ActionHeader_countText__szmso"};